<template>
  <div class="swiper-container">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slides -->
      <div class="swiper-slide">
        <a href="https://blog.yikangbao.com.cn/%E7%94%B5%E5%AD%90%E8%83%B6%E7%89%87%E4%BB%8B%E7%BB%8D">
          <img
            src="@/assets/banner.jpg"
            alt=""
            class="img-fluid">
        </a>
      </div>
    </div>
    <!-- If we need pagination -->
    <div class="swiper-pagination"/>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';

export default {
  name: 'HomeSwiper',
  mounted() {
    this.$nextTick(() => {
      /* eslint-disable no-unused-vars */
      const swiper = new Swiper('.swiper-container', {
        // Optional parameters
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },
      });
    });
  },
};
</script>
